/*
 * Title: 상품 검색 서비스
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 * @Object: GentleServiceInviteMember
 * @Property Value
 * - sponserId: 후원인 아이디 
 * - sponserName: 후원인 이름 
 * @Property Method
 * - selectInviteType: 회원초대방식선택
 * - sponserIsMe: 나를 후원인으로 초대장 생성
 * - sponserIsOther: 다른 사람을 후원인으로 초대장 생성 
 */

import GentleWidget from '../common/widget';
import GentleUtil from '../common/util';
import GentleApi from '../common/api';
import GentleLang from '../common/lang';
import GentleComponentButton from '../component/button';
import GentleComponentBubble from '../component/bubble';
import GentleComponentQuickReply from '../component/quickReply';
import GentleProxy from '../common/proxy';
import GentleServiceProduct from './product';
import language from '../lang';
import GentleAppState from '../common/appstate';
import search from '../lang/search';

// 하이브리드 앱 링크 분기
const browserInfo = window.navigator.userAgent;
const isHybrid = browserInfo.includes('MARKET_GOOGLE') || browserInfo.includes('MARKET_APPSTORE');


var GentleServiceSearch = Object.create( GentleWidget,{
    sponserId:{ writable: true, configurable: false, enumerable: true},
    sponserName: { writable: true, configurable: false, enumerable: true}
})

// 검색
GentleServiceSearch.search = function(SearchKeyword, isFavorite=false){
    // isFavorite : 인기상품
    console.log('GentleServiceSearch.search');
    const component =  Object.create(this);
    const PageSize = 2;
    let shown = 0;
    let curPage = 0;

    const request = function(PageNo = 1){
        const onSuccess = function(data){
            console.log('GentleServiceSearch.search onSuccess>', data);
            switch(data.result){
            case "200":
                const { items } = data;
                console.log('Data>', items);

                if(items){
                    curPage = PageNo;
                    shown = (curPage - 1) * PageSize + items.length;
                }
                    
                render(data, isFavorite, SearchKeyword);
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const searchKeyword = SearchKeyword
        const sorting = [{"memPvRatio":"asc"}]
        const proxy = Object.create(GentleProxy);

        // let formData = new FormData(); // new FromData()로 새로운 객체 생성
        // formData.append("searchKeyword", searchKeyword); // <input name="item" value="hi"> 와 같다.
        // formData.append("sorting", sorting);
        // formData.append("from", "0");
        // formData.append("size", "2");
        // proxy.requestFormData("global-product", formData, onSuccess, onFailed );
        // --> 2025.2 수정
        const formData = {
            "searchKeyword": searchKeyword,
            "sorting": sorting,
        }
        proxy.requestEx({proxy:"2025-product", param:formData, onSuccess, onFailed, isHidden: true});
    }

    const render = function(data, isFavorite=false, SearchKeyword){
        const {items, resultCount} = data;
        let { isLogin } = GentleAppState;

        // 봇버블
        if(resultCount === 0){
            const html = GentleLang.translateService(language.search, language.search.type.ResultBotNotFound, {count: resultCount});
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({                    
                html,
            });
            bubble.insert();
        }
        else if(curPage === 1) // 첫페이지
        {
            let html;
            if (resultCount <= 2) {
                html = GentleLang.translateService(language.search, language.search.type.LessTwoProduct, {
                    count:resultCount
                });

                if (!isLogin)
                    html = GentleLang.translateService(language.search, language.search.type.ResultBotNotLogin, {
                        count: resultCount

                    });

                if (resultCount == 0)
                {
                    html = GentleLang.translateService(language.search, language.search.type.ResultBotNotFound);
                }
            }
            else{
                //{count}개의 상품을 검색했어요. [상품 더보기]를 누르면 다음 상품 검색결과를 볼 수 있어요.',
                html = GentleLang.translateService(language.search, language.search.type.ResultBotFound, {count: resultCount});
                if (!isLogin)
                    html = GentleLang.translateService(language.search, language.search.type.ResultBotNotLogin, {count: resultCount});
            }

            if(isFavorite){
                html = GentleLang.translateService(language.search, language.search.type.BestKeywordSearch, {num: resultCount, keyword: SearchKeyword});
            }


            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }
        else // 검색결과를 더 보여드릴게요.
        {
            let html = GentleLang.translateService(language.search, language.search.type.ResultMore);
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        // products
        if(resultCount > 0)
        {
            const buttons = [
                {
                    send: false,
                    title: GentleLang.translateService(language.search, language.search.type.quickPreResult),
                    text: GentleLang.translateService(language.search, language.search.type.quickPreResult),
                    onClick: function() {
                        console.log('이전 검색 검색');
                        // todo 
                        render(data);
                    }
                },
                {
                    send: false,
                    title: GentleLang.translateService(language.search, language.search.type.Retry),
                    text: GentleLang.translateService(language.search, language.search.type.Retry),
                    onClick: function() {
                        console.log('다시 검색');
                        // todo 
                        GentleServiceSearch.main();
                    }
                },
            ];

            const $container = GentleServiceProduct.list(items, buttons);
            component.insertElement($container);
        }

        // button
        // todo : 상품목록이 남아있으면... 이건 서버로직과 연관...
        if(resultCount > 0){
            if(curPage === 1){
                if(resultCount > shown)  // 2개 이상의 레코드 존재
                {
                    const text = GentleLang.translateService(language.search, language.search.type.SearchNext);
                    const option = [
                        {
                            isSecondary: true,
                            send: false,
                            isCardWidth: true,
                            text: text,
                            user: 'user',
                            onClick: function () {
                                console.log('상품더보기');
                                // render(data, start + 2);
                                request(curPage + 1);
                            },
                        },
                    ]
                    var button = Object.create( GentleComponentButton);
                    button.createComponent(option);
                    button.insert();
                }
               
            }
            else // 첫페이지가 아닌 경우 
            {
                // 
                const text = GentleLang.translateService(language.search, language.search.type.PreResult);
                let option = [
                    {
                        send: false,
                        isSecondary: true,
                        isCardWidth: true,
                        text: text,
                        user: 'user',
                        onClick: function () {
                            console.log('이전 검색결과');
                            // start = start - 2;
                            // if(start < 0) start = 0;
                            // render(data, start);
                            request(curPage - 1);
                        },
                    },
                ]

                // 검색결과 더보기
                if(resultCount > shown){
                    const text = GentleLang.translateService(language.search, language.search.type.SearchNext);
                    option = option.concat(
                        {
                            send: false,
                            isSecondary: true,
                            isCardWidth: true,
                            text: text,
                            user: 'user',
                            onClick: function () {
                                console.log('검색결과 더보기');
                                // render(data, start + 2);
                                request(curPage + 1);
                            },
                        },
                    )
                }

                var button = Object.create( GentleComponentButton);
                button.createComponent(option);
                button.insert();
            }
                // // 애터미 영상 보러가기
            {
                const text = GentleLang.translate(GentleLang.type.VisitVideo);
                const option = [
                    {
                        send: false,
                        isHidden: true,
                        isSecondary: true,
                        isCardWidth: true,
                        text: text,
                        user: 'user',
                        onClick: function () {
                            console.log('애터미 영상 보러가기');
                            return isHybrid ? location.href=language.url.pc.ChannelAtomyMedia 
                                : (GentleAppState.isPc) ? 
                                    window.open(language.url.pc.ChannelAtomyMedia) 
                                    : window.location.href = language.url.mobile.ChannelAtomyMedia;
                        },
                    },
                ]
                var button = Object.create( GentleComponentButton);
                button.createComponent(option);
                button.insert();
            }
        }
        else // 검색결과 없다.
        {
            {
                const text = GentleLang.translate(GentleLang.type.AtomyNewProduct);
                const option = [
                    {
                        // isSecondary: true,
                        // isCardWidth: true,
                        text: text,
                        user: 'user',
                        onClick: function () {
                            console.log('애터미 신상품보기');
                        },
                    },
                ]
                var button = Object.create( GentleComponentButton);
                button.createComponent(option);
                button.insert();
            }
            // {
            //     const text = GentleLang.translate(GentleLang.type.AtomyBestProduct);
            //     const option = [
            //         {
            //             isSecondary: true,
            //             // isCardWidth: true,
            //             text: text,
            //             user: 'user',
            //             onClick: function () {
            //                 console.log('애터미 인기상품 보기');
            //             },
            //         },
            //     ]
            //     var button = Object.create( GentleComponentButton);
            //     button.createComponent(option);
            //     button.insert();
            // }
        }

        // quickReplay
        {
            const buttons = [
                {
                    title: GentleLang.translateService(language.search, language.search.type.Retry),
                    text: GentleLang.translateService(language.search, language.search.type.Retry),
                    send: false,
                    onClick: function() {
                        console.log('다시검색');
                        GentleServiceSearch.main();
                    }
                },
                // {
                //     title: GentleLang.translate(GentleLang.type.BestProduct),
                //     text: GentleLang.translate(GentleLang.type.BestProduct),
                //     onClick: function() {
                //         console.log('인기상품');
                //     }
                // },
                {
                    title: GentleLang.translate(GentleLang.type.NewProduct),
                    text: GentleLang.translate(GentleLang.type.NewProduct),
                    onClick: function() {
                        console.log('신상품');
                        // GentleServiceProduct.newList();
                    }
                },
            ];
            var quickReply = Object.create( GentleComponentQuickReply);   
            quickReply.createComponent(buttons);
            quickReply.insert();
        }
        GentleUtil.timeStamp();
    };

    request();
}

/*
2025.2 - 인기 키워드
"example": {
  "request": {
    "method": "GET",
    "url": "https://oaqa.atomyn.com/chatbot/search/getPopularKeywords",
    "headers": {
      "Authorization": "Bearer {access_token}",  // 사용자 인증 토큰
      "siteno": "{siteno}",  // 사이트 번호
      "locale": "{language}_{siteno}"  // 사이트 언어 및 번호
    }
  },
  "response": {
    "result": "200",  // 응답 코드 (성공)
    "resultMessage": "SUCCESS",  // 응답 메시지
    "siteNo": "KR",  // 요청한 사이트 번호
    "locale": "ko_KR",  // 요청한 사이트 언어 및 번호
    "time": "2025-02-20T13:16:34.856606734+09:00[Asia/Seoul]",  // 응답 시간
    "item": {
      "interestedWord": [  // 인기 키워드 목록
        "they told me",
        "003447",
        "화장품",
        "000829",
        "000933",
        "004025",
        "how long from",
        "if you're enjoying it with me",
        "young man",
        "되는 되는 거"
      ]
    }
  }
}
*/

GentleServiceSearch.main = function(){    
    console.log('GentleServiceSearch.main');
    console.log('검색시에 나와야하는 로그');
    
    const component =  Object.create(this);

    // element 참조 변수 선언
    const cards = [];
    let $input_search;  // 검색 입력필드
    let $category;
    let $keyword;
    // let $result;

    let categories = [];  // 카테고리 목록
    let keywords = [];    // 인기상품 키워드 목록

    let isCategory = false; // 수신여부
    let isKeyword = false; // 수신여부

    const addCategory = function(array){
        array.forEach(element => {     
            // todo : bind data > 카테고리명   
            const title = element.name;
            //20221101 api todo
            const html = `<button>${title}</button>`;
            const $button = $(html);
            cards.push($button);
    
            $button.bind('click', function(){

                // 버블
                const html = `${title}`;
                GentleComponentBubble.insertUserBubble({html, send: false})
                GentleServiceSearch.category(element);

                // 
            });
    
            $category.append($button);
        });    
    }

    const requestCategory = function(){
        console.log("GentleServiceSearch.main -> requestCategory")
        const onSuccess = function(data){
            switch(data.result){
            case "200":
                // 2025.2 수정
                isCategory = true;
                const { items } = data;
                if(items.length > 0){
                    console.log('categories 데이터 있음');
                    categories = items;
                }    

                if(isKeyword){
                    // 두가지 데이터를 다 수신함
                    render();
                }
                else{
                    console.log('keywords 데이터 미수신');
                }

                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);

        // proxy.request("global-categories", {upperId:2402000010}, onSuccess, onFailed );
        // --> 2025.2 수정
        proxy.request("2025-categories", {upperId:2402000010}, onSuccess, onFailed );
    }

    // 2025.2 인기 키워드 조회 - 기존과 동일
    const addKeyword = function(array){
        array.forEach(elem => {   
            // 2022-api : 제품인기 키워드
            // const element = {
            //     Keyword: elem.Keyword
            // }
            const html = `<button>${elem}</button>`;
    
            const $button = $(html);
            cards.push($button);
    
            $button.bind('click', function(){
                // console.log(element);
                const html = elem;
                GentleComponentBubble.insertUserBubble({html, send: false})
                GentleServiceSearch.search(elem, 1, true);
            });
    
            $keyword.append($button);
        });    
    }

    const requestKeyword = function(){
        const onSuccess = function(data){
            console.log('requestKeyword onSuccess', data);
            switch(data.result){
            case "200":
                isKeyword = true;
                const { item } = data;
                const { interestedWord } = item;
                if(interestedWord.length > 0){
                    keywords = interestedWord;
                }    
                else{
                    console.log('keywords 데이터 없음');
                }

                if(isCategory) {
                    render();
                }
                else{
                    console.log('categories 데이터 미수신');
                }

                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);
        // proxy.request("global-searchkeywords", {}, onSuccess, onFailed );
        // --> 2025.2 수정
        console.log('2025 키워드 요청');
        proxy.request("2025-searchkeywords", {}, onSuccess, onFailed );
    }

    const render = function(){
        // 봇버블
        {
            const html = GentleLang.translateService(language.search, language.search.type.MainBot);
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        // 
        {
            const placeholder = GentleLang.translateService(language.search, language.search.type.Placeholder);
            const titleCategory = GentleLang.translate(GentleLang.type.Category);
            const titleKeyword = GentleLang.translate(GentleLang.type.BestKeyword);

            const button_title = GentleLang.translate(GentleLang.type.ButtonMore);

            let html = `
            <div class="card-view">
                <div class="search-product-container">
                    <div class="search-field">
                        <input type="text" placeholder="${placeholder}">
                        <i class="at-icon at-search at-2x"></i>
                    </div>
                    <hr class="mt-20">
                    <h3>${titleCategory}</h3>
                    <div class="gentle-quickreply-group btn-white" name="category">
                    </div>
                    <hr class="mt-20">
                    <h3>${titleKeyword}</h3>
                    <div class="gentle-quickreply-group btn-white" name="keyword">
                    </div>
                </div>
            </div>
            `;

            // component 초기화. 이 코드 후에 레퍼런스로 접근
            {
                let $container = $(html)
                component.setPrefix("search");
                component.init($container);
                component.insert();
            }

            // bind
            {
                // $list = component.find('.list');
                // $result  = component.find('[name="result"]');
                $category = component.find('[name="category"]');
                $keyword = component.find('[name="keyword"]');
            }

            const doSearch = function(){
                const text = $input_search.val().trim();
                // search(text);
                console.log('search : ', text);
                if(text.length === 0) return;
            
                $input_search.val('');
                {
                    GentleComponentBubble.insertUserBubble({html:text, send:false});
                    GentleServiceSearch.search(text);
                }
            }
            // 키워드 엔터
            {
                $input_search = component.find('input');
                $input_search.keydown(function(key) {
                    if (key.keyCode == 13) {
                        const text = $input_search.val();
                        doSearch(text);
                        $input_search.val('');
                        $input_search.attr("readonly",true);
                        $input_search.focus();
                        setTimeout(function(){ $input_search.attr("readonly",false);}, 50);
                    }
                });
            }

            {
                component.find('.at-search').bind('click',function() {
                    doSearch();
                });
            }

            addCategory(categories);
            addKeyword(keywords);

        }
        GentleUtil.timeStamp();
    };
    // render();
    requestCategory();
    requestKeyword();
}

// 상품정보
GentleServiceSearch.info = function(data){
    console.log('GentleServiceSearch.info', data);
    const component =  Object.create(this);

    const render = function(data){
        console.log('render>', data);
        // 봇버블
        {
            const html = GentleLang.translateService(language.search, language.search.type.MoreCategory);
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        // 템플릿 삽입형
        {
            ///// todo : data bind
            // const {ThumbImageUrl, Name, CustPrice, PvPrice, MobileDetailUrl, PCDetailUrl} = data;
            // const {images} = data;
            // const ThumbImageUrl = (images && images.length > 0) ? images[0].file : ""
            // const {name:Name, memSalePrice: CustPrice, pvPrice:PvPrice, image:PCDetailUrl, image:MobileDetailUrl} = data;
            function changeData(data) {
                if(data.images !== undefined) {
                    console.log('data.images 있음');
                    const { imageUrl:images } = data
                    const ThumbImageUrl = (images && images.length > 0) ? images[0]: ""

                    const PCDetailUrl = ThumbImageUrl;
                    const MobileDetailUrl = ThumbImageUrl;

                    const {
                        name:Name, 
                        memRetailPrice: CustPrice, 
                        pvPrice:PvPrice, 
                    } = data;
    
                    return { ThumbImageUrl, Name, CustPrice, PvPrice, PCDetailUrl, MobileDetailUrl }
    
                }else {
                    console.log('data.images 없음');
                    const { imageUrl:images } = data;
                    const PCDetailUrl = images[0];
                    const MobileDetailUrl = images[0];
                    const ThumbImageUrl = images[0];
                    const { 
                        name:Name, 
                        memRetailPrice:CustPrice, 
                        pvPrice:PvPrice, 
                    } = data;
    
                    return { ThumbImageUrl, Name, CustPrice, PvPrice, PCDetailUrl, MobileDetailUrl }
                }
            }

            let { ThumbImageUrl, Name, CustPrice, PvPrice, PCDetailUrl, MobileDetailUrl } = changeData(data)

            const price = GentleLang.translate(GentleLang.type.CurrencyFormat3, {num:  GentleUtil.comma(CustPrice)});

            const pvPrice = GentleUtil.comma(PvPrice);
            const copyString = GentleAppState.isPc? PCDetailUrl : MobileDetailUrl;
            ///// end

            const button_basket = GentleLang.translate(GentleLang.type.AddCart);
            const alarm = GentleLang.translateService(language.product, language.product.type.AlarmRegist);


            let badge = '';
            {
                let {IsNew, IsSaleLimit, IsSaleSeason, IsSoldOut, IsReOpenNotifyMode} = data;

                if(IsNew) badge += `
                <i class="at-badge at-new"></i>`;
                if(IsSaleLimit) badge += `
                <i class="at-badge at-limited"></i>`;
                if(IsSaleSeason) badge += `
                <i class="at-badge at-season"></i>`;
                if(IsSoldOut&&IsReOpenNotifyMode) badge += `
                <i class="at-badge at-soldout"></i>`;
            }

            let switchButton = (data.IsSoldOut && data.IsReOpenNotifyMode) ? `<button type="button" class="primary default" name="alarm">${alarm}</button>`: 
                                `<button type="button" class="secondary default" name="basket">${button_basket}</button>`                                 
    
            let html = `
            <div class="card-view">
                <div class="product-container detail">
                    <div class="product-card">
                        <figure class="product-thumbnail">
                            <img src="${ThumbImageUrl}">  
                            <div class = "icon-container">
                             ${badge}
                            </div>        
                        </figure>
                        <h3>${Name}</h3>
                        <div class="flex-box-2 center">
                            <span>${price}</span>
                            <span><strong class="pv">${pvPrice}</strong> PV</span>
                        </div>
                    </div>           
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            ${switchButton}
                        </div>
                    </div>
                    <button class="floating-circle-button">상품URL 복사</button>
                </div>
            </div>            
            `;

            // component 초기화. 이 코드 후에 레퍼런스로 접근
            {
                let $container = $(html)
                component.setPrefix("productDetail");
                component.init($container);
                component.insert();
            }

            // const $userid = component.find('[name="userid"]');
            // button
            component.find('[name="alarm"]').bind('click',function() {
                let url = (GentleAppState.isPc) ? language.url.pc.ProductDetails : language.url.mobile.ProductDetails;
                        console.log(data);
                        const {Id} = data;
                        url = url.GentleFormat({Id});
                        console.log('url>', url);
                        window.open(url);
            });
            // 구매(컨펌 필요)
            component.find('[name="buy"]').bind('click',function() {
                console.log('바로 구매',data)    
                GentleServiceProduct.popupOption(data, true);    
            });
            // 장바구니
            component.find('[name="basket"]').bind('click',function() {
                // data.buy = false;
                console.log('장바구니 담기', data);
                GentleServiceProduct.popupOption(data, false);
            });
            // 링크
            component.find('.floating-circle-button').bind('click',function() {
                let urlCopy = (GentleAppState.isPc) ? language.url.pc.ProductDetails : language.url.mobile.ProductDetails;
                console.log(data);
                function idChecking(data) {
                    if(data.materialCode === undefined){
                      const { Id } = data;
                      return Id 
                    }else {
                      const { materialCode: Id } = data;
                      return Id 
                    } 
                  }
        
                const Id = idChecking(data)

                urlCopy = urlCopy.GentleFormat({Id});

                console.log('링크복사>', urlCopy);
                GentleUtil.copyTextToClipboard(urlCopy, function(result){
                    if(result === true){
                        GentleUtil.createToastMessage(GentleLang.translate(GentleLang.type.CopiedURL));
                    }else{
                        GentleUtil.createToastMessage(GentleLang.translate(GentleLang.type.FailedCopyURL));
                    }
                });
            });
        }
    };

    render(data);
}

// 중카테고리 선택
GentleServiceSearch.category = function(data){
    console.log('GentleServiceSearch.category>', data);
    const component =  Object.create(this);

    // todo : data bind
    const {name, id} = data; // '[대카테고리]';    // data.title

    // element 참조 변수 선언
    let $category;
    const cards = [];

    let categories;

    // api
    const request = function(){
        const onSuccess = function(data){
            console.log('onSuccess>', data);
            switch(data.result){
            case "200":
                const { items } = data;

                const array = [];
                items.forEach(element => {
                    const {MiddleClass} = element;
                    // if(MiddleClass != '00'){
                        console.log('title', element);
                        array.push(element);
                    // }
                    // else{
                        // console.log('skip', element);
                    // }
                });
                /**
                2차 카테고리 추출
                Requset Paremeter
                LargeClass : 1차카테고리 코드
                if( LargeClass = 1차카테고리 코드 && MiddleClass != 00 && SmallClass = 00 ){
                    2차카테고리 코드 = MiddleClass
                    2차카테고리 이름 = Title
                }
                 */

                if(array.length > 0){
                    categories = array;
                    console.log("중카테고리 배열", array)
                    render();
                }
                else{   // 중카테고리가 존재 안함
                    GentleServiceSearch.search(name);
                }
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);
        // proxy.request("categoriesLarge", {LargeClass}, onSuccess, onFailed );
        // proxy.request("global-categories", {upperId:id}, onSuccess, onFailed );
        // --> 2025.2 수정
        proxy.request("2025-categories", {upperId:id}, onSuccess, onFailed );
    }

    const addCategory = function(array){
        console.log("addCategory")
        // 카테고리
        array.forEach(element => {
            // todo : data bind            
            const {name} = element; // '중카테고리'; // 2025.2 {id, name}

            // 2025.2 카테고리 목록 조회 - 기존과 동일
            const html = `<button >${name}</button>`;            
            const $button = $(html);
            cards.push($button);
    
            $button.bind('click', function(){
                GentleComponentBubble.insertUserBubble({html: name, send: false});
                GentleServiceSearch.middleClass(element, data);  // (선택카테고리, 이전카테고리)
            });
    
            $category.append($button);
        });        
    }

    const render = function(data){
        // 봇버블
        {
            const html = GentleLang.translateService(language.product, language.product.type.CategoryBot, {category: name});
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        // 
        {
            const title = GentleLang.translate(GentleLang.type.Category);

            let html = `
            <div class="card-view">
                <div class="search-product-container">        
                    <h3>${title}</h3>
                    <div class="gentle-quickreply-group btn-white" name="category">
                    </div>
                </div>
            </div>            
            `

            // component 초기화. 이 코드 후에 레퍼런스로 접근
            {
                let $container = $(html)
                component.setPrefix("category");
                component.init($container);
                component.insert();
            }

            // bind
            {
                $category = component.find('[name="category"]');
            }
        }

        // quickReplay
        {
            const buttons = [
                {
                    title: GentleLang.translateService(language.product, language.product.type.CategoryReselect),
                    // text: GentleLang.translateService(language.product, language.product.type.CategoryReselect),
                    onClick: function() {
                        console.log('이전 카테고리 재선택');
                        GentleServiceSearch.main();
                    }
                },
            ];
            var quickReply = Object.create( GentleComponentQuickReply);   
            quickReply.createComponent(buttons);
            quickReply.insert();
        }
        console.log("11111vvvvv", categories)
        addCategory(categories);
        GentleUtil.timeStamp();
    };

    // render();
    request();
}

// 중카테고리 선택 - 상품검색
GentleServiceSearch.middleClass = function(element, preCategory){
    console.log('GentleServiceSearch.middleClass element>', element);
    console.log('GentleServiceSearch.middleClass preCategory>', preCategory);
    const component =  Object.create(this);

    // todo : data bind
    // const category = '중카테고리';  // element.title ???
    const {id, children} = element;

    // api
    const request = function( PageNo=1 ){
        console.log('GentleServiceSearch.middleClass.request : ', PageNo);

        const PageSize = 2;                
        const onSuccess = function(data){
            console.log('onSuccess> 중카테고리 선택 - 상품검색', data);
            switch(data.result){
            case "200":
                if(data.children){
                    console.log("children이 존재함 한번더 중카테고리", data)
                    GentleServiceSearch.middleClass(element, data);
                }else{ //내부데이터가 children이 없을때 <- 해당 상품 바로 렌더링
                    console.log("자식요소가 없어서 바로 상품 렌더링", data)
                    const { items } = data;
                    console.log('Data>', items);
                    // const {TotalCount, List} = Data;
                    
                    // if(item){
                    //     curPage = PageNo;
                    //     shown = (curPage - 1) * PageSize + item.length;
                    // }
            
                    // data.Title = element.name
                    console.log("해당 카테고리의 id", id)
                    items && GentleServiceSearch.renderClass(id,preCategory);
                }
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);
        const param = {productId:id};
        // proxy.request("global-productInCategory", param, onSuccess, onFailed );
        // --> 2025.2 수정
        proxy.request("2025-productInCategory", param, onSuccess, onFailed );
    }
    request();
}


let PageNo = 1
let selectItemCnt = 0

// 중카테고리에서 받은 상품id를 이용해 list로 뿌려주는 함수
GentleServiceSearch.renderClass = function(materialCode,preCategory){
    console.log('GentleServiceSearch.renderClass materialCode>', materialCode);
    const component =  Object.create(this);
    let curPage = 0;
    let shown = 0;  // 보여진 갯수

    // const {id, children} = element;
    // let curPage = 0;

    // api
    // let firstItemIdx = 0

    const request = function( PageNo ){
        console.log('GentleServiceSearch.renderClass.request : ',materialCode);
        const PageSize = 2;                
        const onSuccess = function(data){
        console.log("호출된 페이지 넘버 => ", PageNo)

            if(PageNo !== 1){
                console.log("PageNo != 1")
                selectItemCnt +=2
            }else{
                selectItemCnt = 0
            }
            console.log("집어넣을 selcetItemCnt", selectItemCnt)
            let renderArr = []
            console.log('onSuccess> 중카테고리 -> 상품리스트', data);
            switch(data.result){
            case "200":
                    console.log("렌더링할 자식요소 값 ===>", data)
                    const { items, totalCount: resultCount } = data;
                    console.log('Data>', items);
                    console.log("length", items.length)
                    // const {TotalCount, List} = Data;
                    // 갱신될 페이지를 request 함수가 받아서 렌더하는 데이터를 변경시킴
                    let circleIdx = selectItemCnt +2

                    if(selectItemCnt > items.length){
                        circleIdx = items.length
                    }
                    shown = circleIdx

                    console.log("before for -> ", selectItemCnt, "인덱스부터 ", circleIdx, "까지\n", shown)

                    for(let i=selectItemCnt ; i < circleIdx ; i++){
                        console.log("page idx = ", i)
                        renderArr.push(items[i])
                    }
                    data.items = renderArr
                    
                    render(data, resultCount, PageNo);
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);
        const param = {categoryId:materialCode};
        // proxy.request("global-productRender", param, onSuccess, onFailed );
        // --> 2025.2 수정
        proxy.request("2025-productRender", param, onSuccess, onFailed );
    }
    request(PageNo);

    const render = function(data, resultCount, PageNo){
        console.log('render>', data);

        // const {TotalCount, Title:category, List} = data
        const {items,Title:category,currentPage} = data

        // 봇버블
        {
            let html;
            console.log('카테고리>>>>', {category}.category)
            // if({category}.category ==="시즌/한정 상품"){
            //     html = GentleLang.translateService(language.search, language.search.type.ProductCategoryResult, {count: items.length, category});
            // }else{
            //     html = GentleLang.translateService(language.search, language.search.type.CategoryResult, {count: items.length, category});
            // }
            
            if(currentPage > 1){
                if(GentleAppState.isLogin){
                    html = GentleLang.translateService(language.search, language.search.type.ResultMore);
                }else{
                    html = GentleLang.translateService(language.search, language.search.type.NoLoginMoreCategory);
                }
            }

            if(!GentleAppState.isLogin){
                html = GentleLang.translateService(language.search, language.search.type.NologinResultBotFound, {count: resultCount});
            }else{
                //{count}개의 상품을 검색했어요. [상품 더보기]를 누르면 다음 상품 검색결과를 볼 수 있어요.',
                html = GentleLang.translateService(language.search, language.search.type.ResultBotFound, {count: resultCount});
            }
                
            
            if(items.length === 0)
                html = GentleLang.translateService(language.search, language.search.type.ResultBotNotFound, {count: resultCount});

            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        // products
        if(items && items.length > 0)
        {
            const buttons = [
                {
                    send: false,
                    title: GentleLang.translateService(language.search, language.search.type.PreResult),
                    text: GentleLang.translateService(language.search, language.search.type.PreResult),
                    onClick: function() {
                        console.log('이전 검색 검색');
                        // todo 
                        render(data);
                    }
                },
                {
                    send: false,
                    title: GentleLang.translateService(language.search, language.search.type.Retry),
                    text: GentleLang.translateService(language.search, language.search.type.Retry),
                    onClick: function() {
                        console.log('다시 검색');
                        // todo 
                        GentleServiceSearch.main();
                    }
                },
            ];
            const $container = GentleServiceProduct.list(items, buttons); // todo : true? 
            component.insertElement($container);
        }

        // button
        if(items.length > 0){
            // 이전/다음 버튼처리
            {
                const option = [];
                if(PageNo > 1)    // 이전 검색결과
                {
                    const text = GentleLang.translateService(language.search, language.search.type.PreResult);
                    option.push({
                        isSecondary: true,
                        send: false,
                        isCardWidth: true,
                        text: text,
                        user: 'user',
                        onClick: function () {
                            console.log('이전 검색결과');
                            request(PageNo - 1, selectItemCnt -=2);
                        },
                    });
                }
                if(resultCount > shown ) // 더 보여줄게 있으면
                {
                    const text = GentleLang.translateService(language.search, language.search.type.SearchNext);
                    option.push({
                        isSecondary: true,
                        send: false,
                        isCardWidth: true,
                        text: text,
                        user: 'user',
                        onClick: function () {
                            console.log('상품 더보기');
                            request(PageNo + 1);
                        },
                    });
                }
                
                if(option.length){
                    var button = Object.create( GentleComponentButton);
                    console.log(option);
                    button.createComponent(option);
                    button.insert();
                }
            }

            // 애터미 영상보러가기
            {
                const text = GentleLang.translate(GentleLang.type.VisitVideo);
                const option = [
                    {
                        send: false,
                        isHidden: true,    
                        isSecondary: true,
                        isCardWidth: true,
                        text: text,
                        user: 'user',
                        onClick: function () {
                            console.log('애터미 영상 보러가기');
                            return (GentleAppState.isPc) ? window.open(language.url.pc.ChannelAtomyMedia) : window.open(language.url.mobile.ChannelAtomyMedia)
                        },
                    },
                ]
                var button = Object.create( GentleComponentButton);
                button.createComponent(option);
                button.insert();
            }
        }
        else // 검색결과 없다.
        {
            {
                const text = GentleLang.translate(GentleLang.type.AtomyNewProduct);
                const option = [
                    {
                        isSecondary: true,
                        isCardWidth: true,
                        text: text,
                        user: 'user',
                        onClick: function () {
                            console.log('애터미 신상품보기');
                        },
                    },
                ]
                var button = Object.create( GentleComponentButton);
                button.createComponent(option);
                button.insert();
            }
            // {
            //     const text = GentleLang.translate(GentleLang.type.AtomyBestProduct);
            //     const option = [
            //         {
            //             isSecondary: true,
            //             isCardWidth: true,
            //             text: text,
            //             user: 'user',
            //             onClick: function () {
            //                 console.log('애터미 인기상품 보기');
            //             },
            //         },
            //     ]
            //     var button = Object.create( GentleComponentButton);
            //     button.createComponent(option);
            //     button.insert();
            // }
        }

        // quickReplay
        {
            const buttons = [
                {
                    send: false,
                    title: GentleLang.translateService(language.product, language.product.type.CategoryReselect),
                    text: GentleLang.translateService(language.product, language.product.type.CategoryReselect),
                    onClick: function() {
                        console.log('이전 카테고리 재선택>', preCategory);
                        GentleServiceSearch.category(preCategory);
                    }
                },
                {
                    send: false,
                    title: GentleLang.translateService(language.search, language.search.type.Retry),
                    text: GentleLang.translateService(language.search, language.search.type.Retry),
                    onClick: function() {
                        console.log('다시 검색');
                        GentleServiceSearch.main();
                    }
                },
            ];
            var quickReply = Object.create( GentleComponentQuickReply);   
            quickReply.createComponent(buttons);
            quickReply.insert();
        }
        GentleUtil.timeStamp();
    };
}
export default GentleServiceSearch;